module.exports = "<!-- updated code -->\n<div class=\"inside-page-main-conatiner sub-pages\"  *ngIf='!showloading'>\n      <!-- <div class=\"order-left-section\"> -->\n     <orderlist [width]=\"winWidth\"></orderlist>\n      <!-- </div> -->\n     \n      <!-- <div class=\"order-right-section\">        -->\n          <!-- <orderdescription></orderdescription>   -->\n          <!-- <router-outlet ></router-outlet> -->\n    <!-- </div> -->\n</div>\n\n\n  \n    "


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/orders.component.html
// module id = ./src/app/orders/orders.component.html
// module chunks = main